export const escapeHtml = (value) => String(value ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');

export const escapeEmailText = (value) => escapeHtml(value).replace(/\r?\n/g, '<br>');

export const normalizeStoreAddressForEmail = (value) => String(value ?? '').trim()
    .replace(/\bStreet\b/g, 'St');

export const escapeEmailAddressLine = (value) => escapeHtml(value)
    .replace(/\b([A-Za-z]\d[A-Za-z])\s+(\d[A-Za-z]\d)\b/g, '$1&nbsp;$2');

export const formatStoreAddressEmailHtml = (emailShell = {}) => {
    const addressParts = [
        emailShell.storeAddressLine1,
        emailShell.storeAddressLine2
    ].map(normalizeStoreAddressForEmail).filter(Boolean);

    const address = addressParts.length > 0
        ? addressParts.join(', ')
        : normalizeStoreAddressForEmail(emailShell.storeAddress || '');

    return escapeEmailAddressLine(address);
};

export const fillEmailPlaceholders = (html, values) => Object.entries(values || {}).reduce(
    (result, [key, value]) => result.replace(new RegExp(`\\{\\{${key}\\}\\}`, 'g'), escapeHtml(value || '')),
    html || ''
);
